import { useParams } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState, useRef } from 'react';
import "./MockTestPage.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const MockTestPage = () => {
 const { test_id } = useParams();
 const navigate = useNavigate();
  const [questions, setQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [userAnswers, setUserAnswers] = useState({});
  const [markedForReview, setMarkedForReview] = useState({});
  const [visitedQuestions, setVisitedQuestions] = useState({});
  const [timeLeft, setTimeLeft] = useState(3600); // default (autowill change from backend)
  const [showPalette, setShowPalette] = useState(false);
  const [language, setLanguage] = useState('en');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [result, setResult] = useState({ correct: 0, incorrect: 0, unanswered: 0 });

  const paletteRef = useRef(null);
  const buttonRef = useRef(null);
const autoSubmitRef = useRef(false);

  useEffect(() => {
    fetch(`https://mocktest.bbmclasses.com/api/get_questions.php?test_id=${test_id}`)
      .then(res => res.json())
      .then(data => {
        if (data.success && data.questions?.length) {
          setQuestions(data.questions);
        } else {
          alert('Failed to fetch questions or no questions found');
        }
      })
      .catch(() => alert('Error fetching questions'));
  }, [test_id]);

  /* -------------------------
     ⭐ NEW TIMER FETCH SYSTEM
     ------------------------- */
  useEffect(() => {
    fetch(`https://mocktest.bbmclasses.com/api/get_test_time.php?test_id=${test_id}`)
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          const minutes = data.time || 60;  
          setTimeLeft(minutes * 60);
        }
      })
      .catch(() => console.log("Timer API error"));
  }, [test_id]);

  // Countdown timer
  useEffect(() => {
  if (isSubmitted) return;

  const timer = setInterval(() => {
    setTimeLeft(prev => (prev > 0 ? prev - 1 : 0));
  }, 1000);

  return () => clearInterval(timer);
}, [isSubmitted]);

useEffect(() => {
  if (timeLeft === 0 && !isSubmitted && !autoSubmitRef.current) {
    autoSubmitRef.current = true;

    toast.error("⏳ समय समाप्त — आपका टेस्ट सबमिट किया जा रहा है!", {
      icon: "⛔",
    });

    setTimeout(() => {
      handleSubmit(true);
    }, 300);
  }
}, [timeLeft, isSubmitted]);

  // Click outside palette
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        showPalette &&
        paletteRef.current &&
        !paletteRef.current.contains(e.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(e.target)
      ) {
        setShowPalette(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showPalette]);

  // Track visited
  useEffect(() => {
    setVisitedQuestions(prev => ({ ...prev, [currentQuestion]: true }));
  }, [currentQuestion]);

  const formatTime = (s) => {
    const m = Math.floor(s / 60);
    const sec = s % 60;
    return `${m.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;
  };

  const handleOptionSelect = (index) => {
    setUserAnswers({ ...userAnswers, [currentQuestion]: index });
  };

  const handleNavigation = (index) => {
    if (index >= 0 && index < questions.length) {
      setCurrentQuestion(index);
    }
  };

  const handleClearResponse = () => {
    const updated = { ...userAnswers };
    delete updated[currentQuestion];
    setUserAnswers(updated);
  };

  const handleSaveAndNext = () => {
    setMarkedForReview(prev => ({ ...prev, [currentQuestion]: false }));
    handleNavigation(currentQuestion + 1);
  };

  const handleMarkForReview = () => {
    setMarkedForReview(prev => ({ ...prev, [currentQuestion]: true }));
    handleNavigation(currentQuestion + 1);
  };

  const handleMarkAndAnswered = () => {
    setMarkedForReview(prev => ({ ...prev, [currentQuestion]: true }));
    handleNavigation(currentQuestion + 1);
  };

  const getButtonClass = (idx) => {
    const marked = markedForReview[idx];
    const answered = userAnswers[idx] !== undefined;
    const visited = visitedQuestions[idx];

    if (answered && marked) return 'bg-purple text-white';
    if (marked) return 'bg-primary text-white';
    if (answered) return 'bg-success text-white';
    if (visited) return 'bg-danger text-white';
    return 'bg-secondary text-white';
  };

  const countStatus = () => {
    let notVisited = 0, answered = 0, notAnswered = 0, review = 0, answeredReview = 0;
    questions.forEach((_, i) => {
      const visited = visitedQuestions[i];
      const marked = markedForReview[i];
      const answer = userAnswers[i] !== undefined;

      if (!visited) notVisited++;
      else if (answer && marked) answeredReview++;
      else if (marked) review++;
      else if (answer) answered++;
      else notAnswered++;
    });
    return { notVisited, answered, notAnswered, review, answeredReview };
  };

  // updated: accept `auto` flag to skip confirm when auto-submitting
  const handleSubmit = (auto = false) => {
    // if manual submit, ask for confirmation
    if (!auto) {
      if (!window.confirm("Are you sure you want to submit the test?")) return;
    }

    // prevent multiple submissions
    if (isSubmitted) return;

    let correct = 0, incorrect = 0, unanswered = 0;

    questions.forEach((q, idx) => {
      if (userAnswers[idx] === undefined) {
        unanswered++;
      } else if (userAnswers[idx] + 1 === Number(q.correct_option)) {
        correct++;
      } else {
        incorrect++;
      }
    });

    setResult({ correct, incorrect, unanswered });
    setIsSubmitted(true);
  };

  const status = countStatus();
  const question = questions[currentQuestion] || {};
  const questionText = language === 'en' ? question.question_text_en : question.question_text_hi;
  const options = language === 'en'
    ? [question.option1_en, question.option2_en, question.option3_en, question.option4_en]
    : [question.option1_hi, question.option2_hi, question.option3_hi, question.option4_hi];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [currentQuestion]);

  return (
    <div className="d-flex flex-column vh-100">
      {/* Header */}
      <header className="bg-primary text-white p-2 fixed-top d-flex justify-content-between align-items-center">
        <div>
          <button className="btn btn-light" ref={buttonRef} onClick={() => setShowPalette(!showPalette)}>☰</button>
        </div>
        <div className="d-flex align-items-center gap-2">
          <strong>{formatTime(timeLeft)}</strong>
          
          <select className="form-select form-select-sm me-2" value={language} onChange={(e) => setLanguage(e.target.value)}>
            <option value="en">English</option>
            <option value="hi">हिन्दी</option>
          </select>
          {!isSubmitted && (
            <button className="btn btn-danger btn-sm" onClick={() => handleSubmit(false)}>Submit</button>
          )}
        </div>
      </header>

      {/* Palette */}
      {showPalette && (
        <div
          ref={paletteRef}
          className="position-fixed bg-white shadow p-3 border rounded"
          style={{ top: '60px', left: '10px', width: '250px', maxHeight: '80vh', overflowY: 'auto', zIndex: 1000 }}
        >
          <h6>Question Palette</h6>
          <div className="mb-2 small">
            <div>Not Visited: <span className="badge bg-secondary">{status.notVisited}</span></div>
            <div>Not Answered: <span className="badge bg-danger">{status.notAnswered}</span></div>
            <div>Answered: <span className="badge bg-success">{status.answered}</span></div>
            <div>Marked: <span className="badge bg-primary">{status.review}</span></div>
            <div>Answered & Marked: <span className="badge bg-purple text-white">{status.answeredReview}</span></div>
          </div>
          <hr className="border-t-2 border-gray-300 my-4" />

          <div className="d-flex flex-wrap gap-2 mt-2">
            {questions.map((_, idx) => (
              <button
                key={idx}
                className={`btn btn-sm ${getButtonClass(idx)}`}
                onClick={() => {
                  setCurrentQuestion(idx);
                  setShowPalette(false);
                }}
              >
                {idx + 1}
              </button>
            ))}
          </div>

          <div style={{ height: '100px' }}></div>
        </div>
      )}

      {/* Main */}
      <main className="flex-grow-1 overflow-auto mt-5 mb-5 px-3 py-3">
        {isSubmitted ? (
          <div className="text-center">
            <h3><strong className="text-success"> Test Submitted Successfully!</strong></h3>
            <h4>Total Questions: {questions.length}</h4>
            <h4>Correct: <strong className="text-success">{result.correct}</strong></h4>
            <h4>Incorrect: <strong className="text-danger">{result.incorrect}</strong></h4>
            <h4>Unanswered: <strong className="text-warning">{result.unanswered}</strong></h4>
            <button
              onClick={() => navigate('/view-solution', {
                state: {
                  responses: userAnswers,
                  questions: questions,
                  language: language,
                }
              })}
              className="btn btn-primary mt-3"
            >
              View Solution
            </button>
          </div>
        ) : questionText ? (
          <>
            <h5>Question {currentQuestion + 1}</h5>

            <p dangerouslySetInnerHTML={{ __html: questionText }}></p>

            <div className="mt-3">
              {options.map((opt, idx) => (
                <div className="form-check mb-2" key={idx}>
                  <input
                    className="form-check-input"
                    type="radio"
                    name={`q-${currentQuestion}`}
                    id={`q-${currentQuestion}-opt-${idx}`}
                    checked={userAnswers[currentQuestion] === idx}
                    onChange={() => handleOptionSelect(idx)}
                  />
                  <label className="form-check-label" htmlFor={`q-${currentQuestion}-opt-${idx}`}>
                    <strong>{String.fromCharCode(65 + idx)}.</strong>{" "}
                    <span dangerouslySetInnerHTML={{ __html: opt }} />
                  </label>
                </div>
              ))}
            </div>

            <div style={{ height: '100px' }}></div>
          </>
        ) : (
          <p>Loading question...</p>
        )}
      </main>
<ToastContainer />
      {/* Footer */}
      {!isSubmitted && (
        <footer className="bg-light fixed-bottom border-top py-2 px-3">
          <div className="mock-footer">
            <div className="footer-row row-1">
              <button onClick={handleMarkForReview} className="btn btn-warning btn-sm">Mark for Review</button>
              <button onClick={() => handleNavigation(currentQuestion - 1)} className="btn btn-outline-secondary btn-sm">Previous</button>
              <button onClick={() => handleNavigation(currentQuestion + 1)} className="btn btn-primary btn-sm">Next</button>
              <button onClick={handleSaveAndNext} className="btn btn-success btn-sm">Save & Next</button>
            </div>

            <div className="footer-row row-2">
              <button onClick={handleMarkAndAnswered} className="btn btn-info btn-sm text-white">Answered & Marked</button>
              <button onClick={handleClearResponse} className="btn btn-outline-danger btn-sm">Clear Response</button>
            </div>
          </div>
        </footer>
      )}

      <style>
        {`.bg-purple { background-color: purple !important; }`}
      </style>
    </div>
  );
};

export default MockTestPage;